import React, { useContext, useState } from 'react'
import Context from '../context/context'
import { PlusCircleIcon, MinusCircleIcon } from '@heroicons/react/solid'

const QuantityEditable = ({ quantity, item }) => {

  const [inputQuantity, setInputQuantity] = useState(quantity);
  const context = useContext(Context);
  const { cartHandler } = context;

  function editQuantity() {
    cartHandler({ item_uuid: item.item_uuid, cart_item_id: item.cart_item_id, item_qty: +inputQuantity, action: "quantity" });
  }

  const onchange = action => cartHandler({ item_uuid: item.item_uuid, cart_item_id: item.cart_item_id, action })

  return (
    <span className='quantityEditable'>
      <span id={`${item.item_uuid}-minus-ico`} onClick={() => onchange('reduction')} style={{ height: '20px' }}>
        <MinusCircleIcon style={{ color: 'red', height: '20px' }} />
      </span>
      <input
        type="number"
        value={inputQuantity}
        onChange={e => setInputQuantity(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && editQuantity()}
        onBlur={e => editQuantity()}
      />
      <span id={`${item.item_uuid}-plus-ico`} onClick={() => onchange('increment')} style={{ height: '20px' }}>
        <PlusCircleIcon style={{ color: 'black', height: '20px' }} />
      </span>
    </span>
  )
}

export default QuantityEditable